
import "@/styles/pages/audioRecorder/index.css";
import "@/pages/recordAudioOnline.js";
import registerViewer from "@/components/viewer";
import registerVideoViewer from "@/components/videoViewer";
import registerOpenVideo from "@/components/openVideo";
import registerSlider from "/framework/components/slider";
import registerFit from "@/components/fit";
import registerLearnMore from "@/components/learnMorePackUp";
import registerOurDomain from "@/components/ourDomain";
import registerStartRecord from "@/components/startRecord";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // free-audio-recorder-online
// online-audio-recorder.php
/* eslint-disable */

const { showTopBanner } = require("./recordSreenOnlineDialog.js");
new Vue({
  created($, apower, LazyLoad) {
    registerOurDomain($, apower);
    $.register = $.registerComponent;
    window.apowerTrans = window.$apTranslations;
    window.apower = apower;
    apower.agents = {};
    if (!apower.getDownloadDomain) {
      apower.getDownloadDomain = function (lang) {
        lang = lang || apower.lang;

        switch (lang) {
          case "zh":
            return "https://download.apowersoft.cn";

          default:
            return "https://download.apowersoft.com";
        }
      };
    }
    function loadApiScript() {
      let url =
        "https://api.apowersoft.com/audio-recorder?apower=1&css=0&lang=" +
        apower.lang;
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.body.appendChild(script);
    }

    if (!$.env.isMobile) {
      loadApiScript();
    }
    registerViewer($, apower);
    registerVideoViewer($, apower);
    registerOpenVideo($, apower);
    registerSlider($, apower);
    registerFit($, apower);
    registerLearnMore($, apower);
    registerStartRecord($, apower);

		$("#startRecordAudioOnline").on("click", (e) => {
			$("#onlineAudioRecorderBox").css('display', 'flex');
			$("#oldAudioIndexBox").hide();
		})
		// hide share box, add timeout to wait component register
		setTimeout(() => {
			let shareList = document.getElementsByClassName('counted-share-vertical');
			for(let i of shareList) {
				i.style.display = 'none';
			}
		}, 10);
      showTopBanner();
  },
});

          })
        